module.exports = __webpack_public_path__ + "img/button-dark-01.3c4e18ae.png";